!function(e,r){"object"==typeof exports&&"object"==typeof module?module.exports=r():"function"==typeof define&&define.amd?define([],r):"object"==typeof exports?exports.storeblocks=r():e.storeblocks=r()}(self,(()=>(()=>{"use strict";var e={306:(e,r,n)=>{n.d(r,{Radio:()=>p});var o=n(15),i=n.n(o);const t=require("@storeblocks/icon");var a=n(341),l=n.n(a),d=n(561),c=n(279),s=n(978);const p=(0,o.forwardRef)(((e,r)=>{var{id:n,name:o,label:t,hint:a,disabled:l=!1,error:d,warning:p,onChange:b,value:u,options:m,direction:v,hintProps:h,labelPopoverProps:w}=e,y=function(e,r){var n={};for(var o in e)Object.prototype.hasOwnProperty.call(e,o)&&r.indexOf(o)<0&&(n[o]=e[o]);if(null!=e&&"function"==typeof Object.getOwnPropertySymbols){var i=0;for(o=Object.getOwnPropertySymbols(e);i<o.length;i++)r.indexOf(o[i])<0&&Object.prototype.propertyIsEnumerable.call(e,o[i])&&(n[o[i]]=e[o[i]])}return n}(e,["id","name","label","hint","disabled","error","warning","onChange","value","options","direction","hintProps","labelPopoverProps"]);if(d&&p)throw new Error("Cannot assign both error and warning properties, must choose one or the other.");const $=`${n}-radio-label`,k=`${n}-radio-error`,O=`${n}-radio-warning`,E=`${$} ${O} ${k}`;return i().createElement(c.RadioBase,Object.assign({role:"radiogroup",ref:r,$error:d,$warning:p,"aria-disabled":l,"aria-labelledby":E},y),i().createElement(x,{errorId:k,error:d,warningId:O,warning:p}),i().createElement(g,{warning:p,error:d,label:t,labelId:$,labelPopoverProps:w}),i().createElement(f,{hint:a,hintProps:h}),i().createElement(s.RadioOptions,{id:n,name:o,onChange:b,value:u,options:m,disabled:l,direction:v}))}));function b({warningId:e,warning:r}){return i().createElement(c.Attention,{id:e,role:"alert",$warning:r},i().createElement(t.SystemIcon,{name:"warning-filled"}),r)}function u({errorId:e,error:r}){return i().createElement(c.Attention,{id:e,role:"alert",$error:r},i().createElement(t.SystemIcon,{name:"error-filled"}),r)}function x({warningId:e,warning:r,errorId:n,error:o}){return o?i().createElement(u,{errorId:n,error:o}):r?i().createElement(b,{warningId:e,warning:r}):null}function g({warning:e,error:r,label:n,labelId:o,labelPopoverProps:t}){const a=!(!e&&!r);return n?i().createElement(c.MainLabel,{id:o,attention:a},n,t&&i().createElement(d.Popover,Object.assign({},t),t.children)):null}function f({hintProps:e,hint:r}){return r?i().createElement(l(),Object.assign({},e),r):null}},978:(e,r,n)=>{n.d(r,{RadioOptions:()=>u});var o=n(15),i=n.n(o),t=n(561),a=n.n(t);const l=require("@storeblocks/box");var d=n.n(l),c=n(341),s=n.n(c);const p=e=>e.map((e=>{if(e.id){if(e.id.indexOf(" ")>=0)throw new Error(`The ID [${e.id}] cannot contain spaces.`);return Object.assign({},e)}return Object.assign(Object.assign({},e),{id:e.label.replace(" ","-")})}));var b=n(279);function u({id:e,name:r,direction:n,options:o,value:t,disabled:l,onChange:c}){const u=p(o),x=e=>{var r,n;if(!l&&"true"!==(null===(n=null===(r=e.target.attributes)||void 0===r?void 0:r["aria-disabled"])||void 0===n?void 0:n.value)){const{value:r}=e.target,n=o.find((e=>e.value===r));c(e,n)}};return i().createElement(b.Options,{direction:n},u.map((n=>{const o=`label-${e}-${n.id}`,c=`${e}-${n.id}`,p=`option-hint-${c}`,u=`option-info-${c}`,g=t&&n.value!==t?-1:0;return i().createElement(i().Fragment,{key:c},i().createElement(d(),{background:"inherit"},i().createElement("input",Object.assign({type:"radio",name:r,id:c,key:c,value:n.value,checked:t===n.value,onChange:x,"aria-disabled":l||n.disabled,"aria-labelledby":o,"data-trackid":n.trackid},n.inputProps)),i().createElement(b.Label,Object.assign({id:o,htmlFor:c,checked:t===n.value,"aria-disabled":l||n.disabled},n.labelProps),i().createElement(b.LabelText,null,n.label)),n.info&&i().createElement(a(),Object.assign({buttonProps:{tabIndex:g}},n.popoverProps),n.info)),n.hint&&i().createElement(s(),Object.assign({id:p},n.hintProps),n.hint),n.info&&i().createElement(b.AriaInfo,{id:u},n.info))})))}},279:(e,r,n)=>{n.d(r,{AriaInfo:()=>p,Attention:()=>l,Label:()=>c,LabelText:()=>s,MainLabel:()=>a,Options:()=>d,RadioBase:()=>t});const o=require("styled-components");var i=n.n(o);const t=i().div`
  /*
   Make the element only as wide as the content.
  */
  display: inline-flex;
  flex-direction: column;

  line-height: 16px;
  font-size: 16px;
  font-family: 'Open Sans';
  color: var(--color-on-background);
  background: inherit;

  outline-offset: -3px;

  & input {
    position: absolute;
    clip: rect(1px, 1px, 1px, 1px);
    height: 1px;
    width: 1px;
    opacity: 0;
    overflow: hidden;
  }

  & > .hint {
    margin: -8px 0 16px 0;
  }

  ${({$warning:e})=>e&&o.css`
      background: var(--color-warning-background);
      outline: 3px solid var(--color-warning-accent);
      padding: 0 32px 8px 0;

      & .box {
        background: var(--color-warning-background);
      }

      & > .hint {
        margin: -8px 0 16px 16px;
      }

      & > ${d} {
        margin-left: 16px;
      }
    `}

  ${({$error:e})=>e&&o.css`
      background: var(--color-error-background);
      outline: 3px solid var(--color-error-accent);
      padding: 0 32px 8px 0;

      & .box {
        background: var(--color-error-background);
      }

      & > .hint {
        margin: -8px 0 16px 16px;
      }

      & > ${d} {
        margin-left: 16px;
      }
    `}

  ${e=>e["aria-disabled"]&&o.css`
      color: var(--color-disabled);
    `}
`,a=i().p`
  display: flex;
  align-items: center;

  font-weight: 600;
  line-height: 24px;
  word-wrap: break-word;

  margin-bottom: 16px;

  ${({attention:e})=>e&&o.css`
      margin: 0 16px 16px 16px;
    `}
`,l=i().div`
  display: flex;
  align-items: center;

  font-weight: 600;
  line-height: 24px;

  padding: 16px 24px 16px 16px;

  & > i {
    font-size: 24px;

    margin-right: 24px;

    ${({$warning:e,$error:r})=>e?"color: var(--color-warning-accent)":r?"color: var(--color-error-accent)":""}
  }
`,d=i().div`
  display: inline-flex;
  flex-direction: column;

  & > .hint {
    margin: 8px 40px;

    & a {
      font-size: 14px;
    }
  }

  & > .box {
    & > label + label {
      margin-top: 8px;
    }

    & > input:focus + label {
      outline: var(--outline);
      z-index: 0;
    }

    & > input:focus:not(:focus-visible) + label {
      outline: 0;
      z-index: 0;
    }

    & > input:focus-visible + label {
      outline: var(--outline);
      z-index: 0;
    }
  }

  ${({direction:e})=>"horizontal"===e&&o.css`
      flex-direction: row;

      & > .box + .box {
        margin-top: 0;
        margin-left: 16px;
      }
    `}
`,c=i().label`
  display: flex;
  box-sizing: border-box;

  line-height: 24px;

  user-select: none;
  cursor: pointer;

  &:before {
    content: '';
    display: inline-flex;
    flex-shrink: 0;
    box-sizing: border-box;

    width: 16px;
    height: 16px;
    border-radius: 50%;
    margin: 16px 16px 16px 0;

    border: 2px solid var(--color-on-background);
    background: var(--color-background);

    ${({checked:e})=>e&&"border: 5px solid var(--color-selection)"}
  }

  ${e=>e["aria-disabled"]&&o.css`
      color: var(--color-disabled);
      cursor: not-allowed;

      &:before {
        border-color: var(--color-disabled);
      }
    `}
`,s=i().div`
  padding: 12px 8px 8px 8px;
  line-height: 24px;
`,p=(i().div`
  display: flex;
  flex-direction: column;

  line-height: 24px;

  & > .hint {
    margin-top: 24px;
  }
`,i().div`
  display: none;
`)},341:e=>{e.exports=require("@storeblocks/hint")},561:e=>{e.exports=require("@storeblocks/popover")},15:e=>{e.exports=require("react")}},r={};function n(o){var i=r[o];if(void 0!==i)return i.exports;var t=r[o]={exports:{}};return e[o](t,t.exports,n),t.exports}n.n=e=>{var r=e&&e.__esModule?()=>e.default:()=>e;return n.d(r,{a:r}),r},n.d=(e,r)=>{for(var o in r)n.o(r,o)&&!n.o(e,o)&&Object.defineProperty(e,o,{enumerable:!0,get:r[o]})},n.o=(e,r)=>Object.prototype.hasOwnProperty.call(e,r),n.r=e=>{"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})};var o={};return(()=>{n.r(o),n.d(o,{Radio:()=>e.Radio,default:()=>r});var e=n(306);const r=e.Radio})(),o})()));
//# sourceMappingURL=index.js.map